import { AUTH_PATHS } from "@/constants";
import { Link } from "react-router-dom";

/**
 * Confirmation screen after a successful waitlist submission (presenter only).
 */
export const WaitlistSuccessView = () => {
  return (
    <div className="text-center">
      <div className="mb-8">
        <h2 className="mb-2 text-3xl font-bold text-foreground">You&apos;re on the list</h2>
        <p className="text-muted-foreground">
          You&apos;ve been added to the waitlist. We&apos;ll be in touch when there&apos;s a spot
          for you.
        </p>
      </div>
      <p className="text-sm text-muted-foreground">
        <Link
          to={AUTH_PATHS.SIGNIN}
          className="font-semibold text-primary transition-colors hover:text-primary-hover"
        >
          Sign in
        </Link>
        {" · "}
        <Link
          to="/"
          className="font-semibold text-primary transition-colors hover:text-primary-hover"
        >
          Home
        </Link>
      </p>
    </div>
  );
};
